import * as z from 'zod';

export const GetDefaultPrivacyStatusRequest = z.object({});
export const GetDefaultPrivacyStatusResponse = z.object({
  defaultPrivacy: z
    .object({
      _id: z
        .string()
        .describe('Privacy ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      defaultPrivacy: z
        .enum(['PRIVATE', 'PUBLIC'])
        .describe('Default privacy status for a new member.')
        .optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the default privacy is updated. To prevent conflicting changes, the existing revision must be used when updating default privacy.'
        )
        .optional()
        .nullable(),
    })
    .describe('Retrieved default privacy settings.')
    .optional(),
});
export const SetDefaultPrivacyStatusRequest = z.object({
  defaultPrivacy: z
    .object({
      _id: z
        .string()
        .describe('Privacy ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      defaultPrivacy: z.enum(['PRIVATE', 'PUBLIC']).optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the default privacy is updated. To prevent conflicting changes, the existing revision must be used when updating default privacy.'
        ),
    })
    .describe('Default privacy settings to set.'),
});
export const SetDefaultPrivacyStatusResponse = z.object({
  defaultPrivacy: z
    .object({
      _id: z
        .string()
        .describe('Privacy ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      defaultPrivacy: z
        .enum(['PRIVATE', 'PUBLIC'])
        .describe('Default privacy status for a new member.')
        .optional(),
      revision: z
        .string()
        .regex(/^\d+$/, 'Must be a valid UInt64 string')
        .describe(
          'Revision number, which increments by 1 each time the default privacy is updated. To prevent conflicting changes, the existing revision must be used when updating default privacy.'
        )
        .optional()
        .nullable(),
    })
    .describe('Default privacy settings.')
    .optional(),
});
